// extracted by mini-css-extract-plugin
export default {"wrap":"WmSJ1","wrapper":"uSuYf","cell":"MpbTS","extended":"oigDz"};